/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../client/bills/tender';
import '../../common/tender';
import '../../common/time';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "onboard": {
        "nested": {
          "activation": {
            "nested": {
              "common": {
                "nested": {
                  "BirthDate": {
                    "fields": {
                      "year": {
                        "type": "int32",
                        "id": 1,
                        "rule": "optional"
                      },
                      "month": {
                        "type": "int32",
                        "id": 2,
                        "rule": "optional"
                      },
                      "day": {
                        "type": "int32",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "Name": {
                    "fields": {
                      "firstName": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "lastName": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "Gender": {
                    "values": {
                      "UNKNOWN": 1,
                      "MALE": 2,
                      "FEMALE": 3
                    }
                  },
                  "MerchantAnalytic": {
                    "fields": {
                      "name": {
                        "type": ".squareup.onboard.activation.common.MerchantAnalytic.MerchantAnalyticName",
                        "id": 1,
                        "rule": "optional"
                      },
                      "value": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "MerchantAnalyticName": {
                        "values": {
                          "UNKNOWN": 0,
                          "ESTIMATED_REVENUE": 1,
                          "ESTIMATED_USAGE": 2,
                          "ESTIMATED_EMPLOYEE_COUNT": 3,
                          "PAYMENT_LOCATION": 4,
                          "PAYMENT_TYPE": 5,
                          "CBD_SALES": 6,
                          "CBD_MARIJUANA_DERIVED": 7,
                          "CBD_PROHIBITED_STATE": 8,
                          "CBD_DESCRIPTION": 9,
                          "CBD_SIGNED": 10,
                          "CBD_STATE": 11,
                          "ESTIMATED_MONTHLY_REVENUE": 12
                        }
                      }
                    }
                  },
                  "BeneficialOwnerRole": {
                    "values": {
                      "UNKNOWN_ROLE": 0,
                      "COMPANY_DIRECTOR": 1,
                      "BENEFICIAL_OWNER": 2,
                      "DIRECTOR_AND_BENEFICIAL_OWNER": 3,
                      "PARTNER": 4,
                      "PARTNER_AND_BENEFICIAL_OWNER": 5,
                      "OTHER_MANAGER": 6,
                      "BUSINESS_OWNER": 7,
                      "PERSON_WITH_SIGNIFICANT_CONTROL": 8,
                      "BUSINESS_OWNER_AND_PERSON_WITH_SIGNIFICANT_CONTROL": 9,
                      "NO_OWNERSHIP": 10
                    }
                  },
                  "OwnershipStructure": {
                    "values": {
                      "OS_UNKNOWN": 0,
                      "OS_SOLE_OWNER": 1,
                      "OS_NON_SIGNIFICANT_OWNERS": 2,
                      "OS_BENEFICIAL_OWNERS": 3
                    }
                  },
                  "BankAccountType": {
                    "values": {
                      "UNKNOWN_TYPE": 0,
                      "CHECKING": 1,
                      "SAVINGS": 2,
                      "INVESTMENT": 3,
                      "OTHER": 4
                    }
                  },
                  "UnderwritingStatus": {
                    "values": {
                      "UNKNOWN_UNDERWRITING_STATUS": 0,
                      "PROCESSING": 1,
                      "COMPLETED": 2,
                      "ERRORED": 3,
                      "USER_INFO_REQUIRED": 4
                    }
                  },
                  "Decision": {
                    "values": {
                      "UNKNOWN_DECISION": 0,
                      "APPROVED": 1,
                      "DECLINED": 2
                    }
                  },
                  "AccountOwnershipTransferStatus": {
                    "values": {
                      "UNKNOWN_TRANSFER_STATUS": 0,
                      "TRANSFER_COMPLETED": 1,
                      "TRANSFER_FAILED": 2,
                      "ORIGINAL_DESIGNATE_PII_PENDING_VERIFICATION": 3,
                      "ORIGINAL_DESIGNATE_PII_VERIFICATION_FAILED": 4,
                      "ORIGINAL_EMAIL_PENDING_VERIFICATION": 5,
                      "ORIGINAL_EMAIL_CONFIRMED": 6,
                      "NEW_EMAIL_PENDING_VERIFICATION": 7,
                      "NEW_EMAIL_CONFIRMED": 8,
                      "NEW_EMPLOYEE_PENDING_IDV": 9,
                      "NEW_EMPLOYEE_IDV_FAILED": 10,
                      "POST_IDV_ACTIONS": 11,
                      "POST_IDV_ACTIONS_FAILURE": 12
                    }
                  },
                  "PaymentBrand": {
                    "fields": {
                      "cardBrand": {
                        "type": ".squareup.client.bills.CardTender.Card.Brand",
                        "id": 1,
                        "rule": "optional"
                      },
                      "felicaBrand": {
                        "type": ".squareup.common.tender.FelicaCard.FelicaBrand",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "PaymentBrandEnrollmentStatus": {
                    "fields": {
                      "enrollmentStatus": {
                        "type": ".squareup.onboard.activation.common.PaymentBrandEnrollmentStatus.EnrollmentStatus",
                        "id": 1,
                        "rule": "optional"
                      },
                      "paymentBrand": {
                        "type": ".squareup.onboard.activation.common.PaymentBrand",
                        "id": 2,
                        "rule": "optional"
                      },
                      "enrolledAt": {
                        "type": ".squareup.common.time.DateTime",
                        "id": 3,
                        "rule": "optional"
                      },
                      "approvedAt": {
                        "type": ".squareup.common.time.DateTime",
                        "id": 4,
                        "rule": "optional"
                      },
                      "declinedAt": {
                        "type": ".squareup.common.time.DateTime",
                        "id": 5,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "EnrollmentStatus": {
                        "values": {
                          "INACTIVE": 0,
                          "PENDING": 1,
                          "APPROVED": 2,
                          "DECLINED": 3,
                          "INFO_REQUIRED": 4,
                          "NOT_ALLOWED": 5
                        }
                      }
                    }
                  },
                  "KeyValuePair": {
                    "fields": {
                      "field": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "value": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "CompanyIdentifier": {
                    "fields": {
                      "activationFlowId": {
                        "type": "int32",
                        "id": 1
                      },
                      "merchantToken": {
                        "type": "string",
                        "id": 2
                      },
                      "legalEntityStructureToken": {
                        "type": "string",
                        "id": 3
                      }
                    },
                    "nested": {
                      "value": {
                        "oneof": ["activationFlowId", "merchantToken", "legalEntityStructureToken"]
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.common?.nested?.BirthDate && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.common?.nested?.Name && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.common?.nested?.Gender && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.common?.nested?.MerchantAnalytic && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.common?.nested?.MerchantAnalytic?.nested?.MerchantAnalyticName && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.common?.nested?.BeneficialOwnerRole && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.common?.nested?.OwnershipStructure && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.common?.nested?.BankAccountType && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.common?.nested?.UnderwritingStatus && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.common?.nested?.Decision && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.common?.nested?.AccountOwnershipTransferStatus && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.common?.nested?.PaymentBrand && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.common?.nested?.PaymentBrandEnrollmentStatus && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.common?.nested?.PaymentBrandEnrollmentStatus?.nested?.EnrollmentStatus && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.common?.nested?.KeyValuePair && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.common?.nested?.CompanyIdentifier) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE BirthDate @ squareup/onboard/activation/common.proto at 18:1
 */
export const BirthDate = $root.lookupType('squareup.onboard.activation.common.BirthDate');
fixType(BirthDate, {
  year: {
    required: true
  },
  month: {
    required: true
  },
  day: {
    required: true
  }
});
Builder.createAndAttachToType(BirthDate);
/**
 * SOURCE Name @ squareup/onboard/activation/common.proto at 24:1
 */
export const Name = $root.lookupType('squareup.onboard.activation.common.Name');
fixType(Name);
Builder.createAndAttachToType(Name);
/**
 * SOURCE Gender @ squareup/onboard/activation/common.proto at 37:1
 */
export const Gender = $root.lookupEnum('squareup.onboard.activation.common.Gender').values;
/**
 * SOURCE MerchantAnalytic @ squareup/onboard/activation/common.proto at 43:1
 */
export const MerchantAnalytic = $root.lookupType('squareup.onboard.activation.common.MerchantAnalytic');
fixType(MerchantAnalytic);
Builder.createAndAttachToType(MerchantAnalytic);
/**
 * SOURCE MerchantAnalyticName @ squareup/onboard/activation/common.proto at 47:3
 */
MerchantAnalytic.MerchantAnalyticName = $root.lookupEnum('squareup.onboard.activation.common.MerchantAnalytic.MerchantAnalyticName').values;
/**
 * SOURCE BeneficialOwnerRole @ squareup/onboard/activation/common.proto at 64:1
 */
export const BeneficialOwnerRole = $root.lookupEnum('squareup.onboard.activation.common.BeneficialOwnerRole').values;
/**
 * SOURCE OwnershipStructure @ squareup/onboard/activation/common.proto at 80:1
 */
export const OwnershipStructure = $root.lookupEnum('squareup.onboard.activation.common.OwnershipStructure').values;
/**
 * SOURCE BankAccountType @ squareup/onboard/activation/common.proto at 93:1
 */
export const BankAccountType = $root.lookupEnum('squareup.onboard.activation.common.BankAccountType').values;
/**
 * SOURCE UnderwritingStatus @ squareup/onboard/activation/common.proto at 101:1
 */
export const UnderwritingStatus = $root.lookupEnum('squareup.onboard.activation.common.UnderwritingStatus').values;
/**
 * SOURCE Decision @ squareup/onboard/activation/common.proto at 109:1
 */
export const Decision = $root.lookupEnum('squareup.onboard.activation.common.Decision').values;
/**
 * SOURCE AccountOwnershipTransferStatus @ squareup/onboard/activation/common.proto at 115:1
 */
export const AccountOwnershipTransferStatus = $root.lookupEnum('squareup.onboard.activation.common.AccountOwnershipTransferStatus').values;
/**
 * SOURCE PaymentBrand @ squareup/onboard/activation/common.proto at 131:1
 */
export const PaymentBrand = $root.lookupType('squareup.onboard.activation.common.PaymentBrand');
fixType(PaymentBrand);
Builder.createAndAttachToType(PaymentBrand);
/**
 * SOURCE PaymentBrandEnrollmentStatus @ squareup/onboard/activation/common.proto at 136:1
 */
export const PaymentBrandEnrollmentStatus = $root.lookupType('squareup.onboard.activation.common.PaymentBrandEnrollmentStatus');
fixType(PaymentBrandEnrollmentStatus);
Builder.createAndAttachToType(PaymentBrandEnrollmentStatus);
/**
 * SOURCE EnrollmentStatus @ squareup/onboard/activation/common.proto at 137:3
 */
PaymentBrandEnrollmentStatus.EnrollmentStatus = $root.lookupEnum('squareup.onboard.activation.common.PaymentBrandEnrollmentStatus.EnrollmentStatus').values;
/**
 * SOURCE KeyValuePair @ squareup/onboard/activation/common.proto at 176:1
 */
export const KeyValuePair = $root.lookupType('squareup.onboard.activation.common.KeyValuePair');
fixType(KeyValuePair);
Builder.createAndAttachToType(KeyValuePair);
/**
 * SOURCE CompanyIdentifier @ squareup/onboard/activation/common.proto at 184:1
 */
export const CompanyIdentifier = $root.lookupType('squareup.onboard.activation.common.CompanyIdentifier');
fixType(CompanyIdentifier);
Builder.createAndAttachToType(CompanyIdentifier);